import React, { useState } from 'react'
import Container from '@mui/material/Container'
import GameContainerBackground from './GameContainerBackground'
import { GameDataModel, gamesCachedValue } from './GameDataModel'
import Grid from '@mui/material/Grid2'
import { GameInfoView } from './GameInfoView'
import { GameSelector } from './GameSelector'
import GameToolbar from './GameToolbar'

type Props = {
  game: GameDataModel
}

export function GameContainer({ game }: Props) {
  const [selectedGameId, setSelectedGameId] = useState<string>('splitsease')
  const selectedGame = gamesCachedValue.filter(
    (g) => g.id === selectedGameId,
  )[0]

  return (
    <>
      <GameContainerBackground
        imagePath={selectedGame.coverImagePath}
        videoPath={selectedGame.coverVideoPath}
      />
      <GameToolbar />
      <Grid
        container
        sx={{
          height: '100vh',
        }}
      >
        <Grid size={{ xs: 12, sm: 12, md: 4, lg: 3, xl: 2 }}>
          <GameSelector
            games={gamesCachedValue}
            selectedGameId={selectedGameId}
            setSelectedGameId={setSelectedGameId}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 12, md: 8, lg: 9, xl: 10 }}>
          <GameInfoView game={selectedGame} />
        </Grid>
      </Grid>
    </>
  )
}

export default GameContainer
